import axios from "axios";
import React from "react";
import StorePrice from "../sharedComponent/StorePrice/StorePrice";
// Work for product Category with api products_categories/categories-poducts/
export const categoryProduct = async (id) => {
    try {
        const response = await axios.get(

            `api.milkbun.io/products_categories/categories-poducts/${id}`
        );
        return {
            category: response.data.category,
            products: response.data.category.products
        }
    } catch (err) {
        console.log(err)
    }
}

export const get_lang = (value, langValue) => { 
    var lang = langValue;
    var result = value.en;
    switch (lang) {
        case "en":
            result = value.en;
            break;
        case "ar":
            // result = value.en;
            result = value.ar ? value.ar : value.en;
            break;
            case "ch":
                // result = value.en;
                result = value.ch ? value.ch : value.en;
                break;
        default:
            result = value.en;
            break;
    }

    return result;
}

/** Text-only currency label (for strings); falls back to currencySymbol if value is JSX. */
export const getCurrencyLabel = (storeInfo, langValue) => {
  if (!storeInfo?.storeCurrency) {
    return storeInfo?.currencySymbol ?? "";
  }
  const cur = get_lang(storeInfo.storeCurrency, langValue);
  if (typeof cur === "string" || typeof cur === "number") {
    return String(cur);
  }
  return storeInfo.currencySymbol ?? "";
};

/** Store price (SAR: currency first; KWD etc.: amount first). Use instead of manual get_lang + amount. */
export const renderStorePrice = (amount, storeInfo, langValue, className = "") => (
  <StorePrice
    amount={amount}
    storeInfo={storeInfo}
    langValue={langValue}
    className={className}
  />
);

    export const get_lang_status = (value, langValue) => { 
        var lang = langValue;
        var result = value.en;
        switch (lang) {
            case "en":
                result = value.en ? true : false;
                break;
            case "ar":
                // result = value.en;
                result = value.ar ? true : false;
                break;
            default:
                result = true;
                break;
        }
    
        return result;
    } 


export const get_lang_search = (value, langValue) => {
    var lang = langValue;
    var result = value.en;

    switch (lang) {
        case "en":
            result = value.en;
            break;
        case "ar":
            result = value.en;
            // result = value.ar ? value.ar : value.en;
            break;
        default:
            result = value.en;
            break;
    }

    return result;
}
// work for show product with api showViaSlug
export const showViaSlug = async (slug) => {
    try {
        const response = await axios.get(
            `api.milkbun.io/products/showViaSlug/${slug}`
        );
        return {
            product: response.data.data,
            allAddons: response.data.data.addons
        }
    } catch (error) {
        console.log(error);
    }
}

// work for store information and visible fields
export const storeInfoRes = async (sessionID) => {
    try {
        const stResponse = await axios.get(

            `api.milkbun.io/stores/store/information/${sessionID}`
        );
        // console.log("store Information ", stResponse)
        return stResponse.data.data
    } catch (e) {
        console.log(e);
    }

}

// work for visible fields
export const visibleFieldsRes = async (sessionID) => {
    try {
        const visibleFields = await axios.get(

            `api.milkbun.io/store_visible_fields/show/${sessionID}}`
        );
        return visibleFields.data.data

    } catch (e) {
        console.log(e)
    }

}

// work for  delivery mode
export const serviceModeRes = async (sessionID) => {
    try {
        const serviceModeResponse = await axios.get(

            `api.milkbun.io/store_delivery_modes/show/${sessionID}`
        );
        return serviceModeResponse.data.data;
    }
    catch (e) {
        console.log(e)
    }
}

// work for  areaResponse
export const areaRes = async (sessionID) => {
    try {
        const areaResponse = await axios.get(

            `api.milkbun.io/store_delivery_charges/get-RestaurentAreas/${sessionID}`
        );
        return areaResponse.data.data
    }
    catch (e) {
        console.log(e)
    }
}

// work for user-det
export const userDetRes = async (token) => {
    try {
        const response = await axios.get(
            `api.milkbun.io/user-det`, {
            headers: {
                Authorization: `Bearer ${token}`,
                ContentType: 'application/json',
            }
        }
        );
        return response.data.data

    } catch (e) {
        console.log(e);
    }
}

// work for user Information
export const userInfoRes = async (userId) => {
    try {
        const response = await axios.get(
            `api.milkbun.io/users/shows/${userId}`

        );
        return response.data.data;

    } catch (e) {
        console.log("error geting id");

    }
}

// work for store social link
export const socialLinkRes = async (sessionID) => {
    try {
        const response = await axios.get(

            `api.milkbun.io/store_social_links/show/${sessionID}`

        );
        console.log(response, "Social Link")
        return response.data.data;

    } catch (e) {
        console.log(e, "error geting Social Link");

    }
}
